import { useRouteParams } from "@vueuse/router";
import { useCurrentExperienceMediaQuery } from "@/features/experience-media/composables/useCurrentExperienceMediaQuery";
import { useCurrentRawExperienceQuery } from "@/features/experience-raw/composables/useCurrentRawExperienceQuery";
import { useRevisionStore } from "@/features/experience-revision/store/useRevisionStore";
import { useCurrentExperienceFlow } from "@/features/experience-shared/composables/useCurrentExperienceFlow";
import { useExperienceTranslationStore } from "@/features/experience-translation/stores/useExperienceTranslationStore";
import { useCurationTitle } from "@/features/experience-curation/sections/settings/title/useCurationTitle";
import { DocumentContentType } from "@/types/DocumentStatuses";

export function useExperienceBrowserTitle() {
  const experienceId = useRouteParams<string | undefined>("id");
  const revisionId = useRouteParams<string | undefined>("revisionId");

  const experienceRawQuery = useCurrentRawExperienceQuery();
  const titleStore = useCurationTitle();
  const translationStore = useExperienceTranslationStore();
  const mediaQuery = useCurrentExperienceMediaQuery();
  const revisionStore = useRevisionStore();

  const flow = useCurrentExperienceFlow();

  const title = computed(() => {
    if (!experienceId.value) {
      return "";
    }

    if (revisionId.value) {
      return revisionStore.tabLabel || "";
    }

    switch (flow.value) {
      case DocumentContentType.RAW:
      case DocumentContentType.OPINOIA_OPERATIONAL:
        // Unlike other flows, raw title comes from remote data and supports OPINOIA as well.
        return experienceRawQuery.data.value?.commercial.title || "";
      case DocumentContentType.EDITORIAL:
        return titleStore.model || "";
      case DocumentContentType.TRANSLATION:
        return translationStore.translation.title || titleStore.model;
      case DocumentContentType.MEDIA:
        return mediaQuery.data.value?.title || "";
      default:
        return "";
    }
  });

  useHead({ title });

  return {
    title,
  };
}
